<template>
  <user-form>
    <ButtonUpdate class="mt_m"/>
    <ButtonDelete class="mt_s"/>
  </user-form>
</template>

<script>
import UserForm from '@/components/User/Form'
import ButtonUpdate from '@/components/User/ButtonUpdate'
import ButtonDelete from '@/components/User/ButtonDelete'

export default {
  components: {
    UserForm,
    ButtonUpdate,
    ButtonDelete
  },
  created: async function () {
    await this.$store.dispatch(
      'user/getUser',
      this.$route.params.id
    )
    this.$store.dispatch('user/initForm')
  }
}
</script>
